module.exports = __webpack_public_path__ + "static/media/background.5481169e.png";